'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _moment = require('@alicd/next/lib/moment');

var _moment2 = _interopRequireDefault(_moment);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localeProvider = require('@alicd/next/lib/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _lib = require('@alicd/next/lib/_components/@alicd/next-util/lib');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _rangePickTool = require('./module/range-pick-tool');

var _rangePickTool2 = _interopRequireDefault(_rangePickTool);

var _calendarTable = require('./table/calendar-table');

var _calendarTable2 = _interopRequireDefault(_calendarTable);

var _calendarMixin = require('./calendar-mixin');

var _calendarMixin2 = _interopRequireDefault(_calendarMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RangePickerPanel = function (_Component) {
    (0, _inherits3.default)(RangePickerPanel, _Component);

    function RangePickerPanel(props, context) {
        (0, _classCallCheck3.default)(this, RangePickerPanel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RangePickerPanel.__proto__ || (0, _getPrototypeOf2.default)(RangePickerPanel)).call(this, props, context));

        _this.state = {
            base: props.base ? (0, _moment2.default)(props.base) : (0, _moment2.default)(),
            value: _this.getRangeValue(props.value),
            mode: props.mode,
            animate: false
        };
        return _this;
    }

    (0, _createClass3.default)(RangePickerPanel, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if ('base' in newProps) {
                this.setState({
                    base: newProps.base ? (0, _moment2.default)(newProps.base) : (0, _moment2.default)()
                });
            }

            if ('value' in newProps) {
                this.setState({
                    value: this.getRangeValue(newProps.value)
                });
            }

            if ('mode' in newProps) {
                this.setState({
                    mode: newProps.mode
                });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(needChange, nextState) {
            if (needChange) {
                this.setState(nextState);
            }

            // Important: 兼容 0.x BR
            if (nextState.mode === 'date' && this.props.onSelect) {
                _lib.log.deprecated('onSelect', 'onChange', 'Calendar.RangePickerPanel');
                this.props.onSelect(nextState.value);
            }

            this.props.onChange(nextState);
        }
    }, {
        key: 'onAnimate',
        value: function onAnimate(animate) {
            var _this2 = this;

            this.setState({
                animate: animate
            });

            setTimeout(function () {
                _this2.setState({
                    animate: false
                });
            }, 500);
        }
    }, {
        key: 'getRangeValue',
        value: function getRangeValue(value) {
            var rangeValue = [null, null];

            if (value && value instanceof Array) {
                rangeValue[0] = value[0] ? (0, _moment2.default)(value[0]) : null;
                rangeValue[1] = value[1] ? (0, _moment2.default)(value[1]) : null;
            } else {
                rangeValue[0] = value ? (0, _moment2.default)(value) : null;
            }

            return rangeValue;
        }
    }, {
        key: 'getRangeBase',
        value: function getRangeBase(base) {
            var nextMonth = base.month() + 1;
            var nextYear = base.year() + 1;
            var nextBase = nextMonth > 11 ? (0, _moment2.default)(base).year(nextYear).month(nextMonth % 12) : (0, _moment2.default)(base).month(nextMonth);

            return [base, nextBase];
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames, _classNames2;

            var _props = this.props,
                className = _props.className,
                others = (0, _objectWithoutProperties3.default)(_props, ['className']);

            var prefix = this.context.prefix || others.prefix;
            var _state = this.state,
                value = _state.value,
                base = _state.base,
                mode = _state.mode,
                animate = _state.animate;

            // get range base

            var rangeBase = this.getRangeBase(base);

            var calendarCls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + 'calendar', true), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-card', true), (0, _defineProperty3.default)(_classNames, className, className), _classNames));
            var calendarBodyCls = (0, _classnames2.default)((_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, prefix + 'calendar-body', true), (0, _defineProperty3.default)(_classNames2, prefix + 'calendar-range-body', true), (0, _defineProperty3.default)(_classNames2, '' + animate, animate), _classNames2));

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, (0, _lib.pickAttrs)(others), { className: calendarCls, ref: 'range-picker-panel' }),
                _react2.default.createElement(
                    'div',
                    { className: prefix + 'calendar-header' },
                    _react2.default.createElement(_rangePickTool2.default, (0, _extends3.default)({}, others, { base: base, mode: mode, onChange: this.onChange.bind(this, true), onAnimate: this.onAnimate.bind(this) }))
                ),
                mode === 'month' ? _react2.default.createElement(
                    'div',
                    { className: calendarBodyCls },
                    _react2.default.createElement(
                        'div',
                        { className: prefix + 'calendar-range-body-left' },
                        _react2.default.createElement(_calendarTable2.default, (0, _extends3.default)({}, others, { type: 'card', base: rangeBase[0], value: value, mode: mode, rangeMode: true, onChange: this.onChange.bind(this, false) }))
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: prefix + 'calendar-range-body-right' },
                        _react2.default.createElement(_calendarTable2.default, (0, _extends3.default)({}, others, { type: 'card', base: rangeBase[1], value: value, mode: mode, rangeMode: true, onChange: this.onChange.bind(this, false) }))
                    )
                ) : _react2.default.createElement(
                    'div',
                    { className: calendarBodyCls },
                    _react2.default.createElement(_calendarTable2.default, (0, _extends3.default)({}, others, { type: 'card', base: base, value: value, mode: mode, onChange: this.onChange.bind(this, false) }))
                )
            );
        }
    }]);
    return RangePickerPanel;
}(_react.Component);

RangePickerPanel.propTypes = {
    onChange: _propTypes2.default.func,
    className: _propTypes2.default.string
};
RangePickerPanel.defaultProps = {
    mode: 'month',
    onChange: function onChange() {}
};
RangePickerPanel.contextTypes = {
    prefix: _propTypes2.default.string
};


(0, _calendarMixin2.default)(RangePickerPanel);

exports.default = (0, _localeProvider2.default)(RangePickerPanel);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/view/range-picker-panel.js
// module id = 623
// module chunks = 0